import { LOCALES } from '../../locales';
import { generalFormI18n } from '../shared/form.i18n';

export default {
  [LOCALES.ENG]: {
    ...generalFormI18n[LOCALES.ENG],

    general_app_title: 'App',
    general_app_link_title: 'App link',
    general_sign_in_title: 'Sign in',
    general_username_title: 'Username',
    general_password_title: 'Password',
    general_notes_title: 'Notes',
    general_first_name_title: 'First name',
    general_the_first_name_title: 'The first name',
    general_last_name_title: 'Last name',
    general_the_last_name_title: 'The last name',
    general_email_title: 'Email',
    general_phone_title: 'Phone',
    general_copied_hint_title: 'Copied!',

    // landing page
    developer_landing_header_navigation_gallery: 'Apps Gallery',
    developer_landing_header_navigation_api: 'API Documentation',

    developer_landing_explore_title: 'Explore Our Resources',
    developer_landing_explore_block_api_title: 'Check Out the APIs',
    developer_landing_explore_block_api_description:
      'Get access to our APIs and documentation to start building and integrating applications.  Get access to our APIs and documentation to start building and integrating applications.  Get access to our APIs and documentation to start building and integrating applications.',
    developer_landing_explore_block_sandboxes_title: 'Test in our Sandboxes',
    developer_landing_explore_block_sandboxes_description:
      'Use our isolated sandbox environments to test your apps with the real data before publishing them on Marketplace.',
    developer_landing_explore_block_marketplace_title: 'Grow on Marketplace',
    developer_landing_explore_block_marketplace_description:
      'Launch, promote, and sell your apps on our Marketplace, our app store for customizations and integrations. ',
    developer_landing_questions_title: 'Have questions?',
    developer_landing_questions_description:
      'Our developer support channels are here to help you.',

    // registration page
    developer_registration_form_title: 'Create your account',
    developer_registration_form_current_step:
      'Step {currentStep} of {allStepsCount}',
    developer_registration_form_finish_title: 'Thanks for applying!',
    developer_registration_form_finish_message:
      'Your information has been successfully submitted. We will review it & get back to you within 48 hours. Stay tuned!',

    // portal
    developer_portal_logo: 'Developer Portal',
    developer_portal_welcome:
      'This is your dashboard where you can manage your apps. Get started by adding your very first app.',
    developer_portal_navigation_dashboard: 'My Dashboard',
    developer_portal_navigation_sandboxes: 'Sandboxes',
    developer_portal_navigation_references: 'API References',
    developer_portal_dashboard_navigation_apps: 'Apps',
    developer_portal_dashboard_navigation_apps_counted: 'Apps ({length})',
    developer_portal_dashboard_navigation_app_details: 'App details',
    developer_portal_dashboard_new_app_modal_title: 'New App',
    developer_portal_dashboard_edit_app_modal_title: 'Edit App',
    developer_portal_app_list_label_name: 'Name',
    developer_portal_app_list_label_update: 'Last Update',
    developer_portal_app_list_label_status: 'Status',
    developer_portal_app_list_label_clientid: 'Client ID',
    developer_portal_app_list_label_secret: 'Secret',
    developer_portal_app_api_access_title: 'Sandbox API Access',
    developer_portal_app_api_access_label_clientid: 'Client ID:',
    developer_portal_app_api_access_label_secret: 'Secret:',
    developer_portal_app_desc_form_image_header: 'Drop image here or',
    developer_portal_app_desc_form_image_desc:
      'png, jpg, gif 600x600. Max 10MB',
    developer_portal_app_desc_form_image_select_option: 'select image',
    developer_portal_app_desc_form_images_set_select_option: 'select images',
    developer_portal_app_desc_form_images_set_desc:
      'High resolution images (png, jpg, gif) 1600x1200 or higher recommended. Max 10MB',
    developer_portal_app_details_tab_description: 'General Information',
    developer_portal_app_details_tab_tech_details: 'Technical Details',
    developer_portal_app_details_tab_documentation: 'Documentation',
    developer_portal_app_details_tab_transaction_log: 'Transactions',

    // forms
    form_have_questions_label_name: 'Your name',
    form_have_questions_label_email: 'Email address',
    form_have_questions_label_company: 'Company name',
    form_have_questions_label_name_validation:
      'Name is required and should be valid',
    form_have_questions_label_email_validation:
      'Email is required and should be valid',
    form_registration_name: 'First Name',
    form_registration_lastname: 'Last Name',
    form_registration_email: 'Business Email',
    form_registration_email_option: '(it will be your username)',
    form_registration_phone: 'Phone',
    form_registration_company: 'Company Name',
    form_registration_website: 'Website',
    form_registration_country: 'Country',
    form_registration_state: 'State',
    form_registration_city: 'City',
    form_registration_postal_code: 'Postal Code',
    form_registration_app_desc: 'Describe Your Apps',
    form_registration_download_statement:
      'Please download and read the Legal Statement',
    form_registration_download_statement_option: '(download PDF)',
    form_registration_agree:
      'I have read and accept the terms of the Legal Statement',
    form_registration_name_validation_empty:
      'The first name should not be empty',
    form_registration_lastname_validation_empty:
      'The second name should not be empty',
    form_registration_phone_validation_format:
      'The phone should consist of only with numeric characters',
    form_registration_email_validation_empty:
      'The email should not be empty and with correct email format',
    form_registration_postal_code_validation_format:
      'The postal code should consist of only with numeric characters',
    form_registration_app_desc_validation_empty:
      'The application description should be at least 30 characters length',
    form_registration_agree_validation_empty:
      'You have to agree with the Legal Agreement to proceed',
    form_dashboard_app_name: 'Application Name',
    form_dashboard_app_name_existed: 'Application {name} already exists.',
    form_dashboard_app_descr: 'Short Description',
    form_dashboard_app_type: 'Add Type',
    form_dashboard_app_category: 'Category',
    form_dashboard_app_solution: 'Work with',
    form_dashboard_app_name_validation_empty:
      'The name should not be empty and should consist of at least 2 symbols',
    form_dashboard_app_descr_validation_empty:
      'The description should not be empty and should consist of at least 15 symbols',
    form_dashboard_app_type_validation_empty: 'At least one type is required',
    form_dashboard_edit_type_validation_empty: 'At least one type is required',
    form_dashboard_app_category_validation_empty:
      'At least one category is required',
    form_dashboard_edit_category_validation_empty:
      'At least one category is required',
    form_dashboard_app_solution_validation_empty:
      'At least one solution is required',
    form_dashboard_edit_solution_validation_empty:
      'At least one solution is required',
    form_dashboard_app_description_url: 'URL',
    form_dashboard_app_description_long_desc: 'Long Description',
    form_dashboard_app_description_preview_images: 'Preview Images',
    form_dashboard_app_description_app_icon: 'App Icon',
    form_dashboard_app_description_url_validation_empty:
      'URL should not be empty and should be in correct format',
    form_dashboard_app_description_long_desc_validation_empty:
      'Long desc should not be empty and should consist of at least 15 symbols',

    form_dashboard_app_tech_detls_review_title: 'App Review Info',
    form_dashboard_app_tech_detls_review_subtitle:
      'Please provide username and password so we can sign in to the app and review it.',
    form_dashboard_app_tech_detls_checkbox_title: 'Sign-in required',

    form_dashboard_app_tech_detls_field_validation_req: `{key} is required`,
    form_dashboard_app_tech_detls_phone_field_validation:
      'Please enter a valid phone number',
    form_dashboard_app_tech_detls_review_contact_info_subtitle:
      'Please provide contact info of a person who can be reached in case of additional questions or clarifications.',

    form_dashboard_app_tech_detls_email_field_validation:
      'Please enter a valid email',

    form_dashboard_app_documentation_main_title: 'Tutorials and Documentation',
    form_dashboard_app_documentation_first_subtitle:
      '1 - Tutorial/Documentation',
    form_dashboard_app_documentation_name_label_title: 'Documentation Name',
    form_dashboard_app_documentation_url_label_title:
      'Documentation URL (Optional)',
    form_dashboard_app_documentation_add_docs_title: 'Add More Documentation',
    form_dashboard_app_documentation_add_eula_title:
      'Add EULA (End User License Agreements)',
    form_dashboard_app_documentation_description_title: 'Support Description',
    form_dashboard_app_documentation_license_url_label: 'License URL',

    // buttons
    developer_landing_banner_signup_button: 'Sign Up',
    developer_landing_explore_blocks_button: 'Learn more',
    developer_landing_questions_form_button: 'Send Contact Form',
    developer_registration_form_cancel_button: 'Cancel',
    developer_registration_form_back_button: 'Back',
    developer_registration_form_next_button: 'Next',
    developer_registration_form_submit_button: 'Next',
    developer_registration_form_finish_button: 'Got it!',
    developer_portal_dashboard_app_app_button: 'Add App',
    developer_portal_dashboard_edit_app_button: 'Save App',
    developer_portal_dashboard_form_cancel_button: 'Cancel',
    developer_portal_dashboard_send_for_review_button: 'Send for Review',
    developer_tech_details_form_cancel_button: 'Cancel',
    developer_tech_details_form_save_button: 'Save',
    developer_app_desc_form_cancel_button: 'Cancel',
    developer_app_desc_form_save_button: 'Save',
    form_dashboard_app_documentation_add_license_button: 'Add More License',
  },
};
